// extracted by mini-css-extract-plugin
module.exports = {"InputText":"styles_InputText__0nin6","icon":"styles_icon__jcEgT"};